import { EMPTY_OBJECT } from '../../../constants/common'
import { isValueStringType } from '../../../utils/common'

export function isFormFieldWysiwygErrorShown({
  blocked,
  disabled,
  error,
} = EMPTY_OBJECT) {
  return !disabled && !blocked && isValueStringType(error)
}
